export const FEATURE_NAME = '@zerops/zerops/feature/sudo-reauth';
